import { render, staticRenderFns } from "./LawyerListPage.vue?vue&type=template&id=4861c6fd"
import script from "./LawyerListPage.vue?vue&type=script&lang=js"
export * from "./LawyerListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports